import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowBackIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	"data-rtl-mirror": "true",
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_40_4256",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				transform: "matrix(-1 0 0 1 24 0.5)",
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_40_4256)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M9.52501 12.5L16.875 5.15C17.125 4.9 17.2458 4.60417 17.2375 4.2625C17.2292 3.92083 17.1 3.625 16.85 3.375C16.6 3.125 16.3042 3 15.9625 3C15.6208 3 15.325 3.125 15.075 3.375L7.40001 11.075C7.20001 11.275 7.05001 11.5 6.95001 11.75C6.85001 12 6.80001 12.25 6.80001 12.5C6.80001 12.75 6.85001 13 6.95001 13.25C7.05001 13.5 7.20001 13.725 7.40001 13.925L15.1 21.625C15.35 21.875 15.6417 21.9958 15.975 21.9875C16.3083 21.9792 16.6 21.85 16.85 21.6C17.1 21.35 17.225 21.0542 17.225 20.7125C17.225 20.3708 17.1 20.075 16.85 19.825L9.52501 12.5Z",
				fill: "white"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgArrowBackIcon);
export default ForwardRef;
